import { render } from "./ProcessItemAdminUser.vue?vue&type=template&id=11ad939f&scoped=true&ts=true"
import script from "./ProcessItemAdminUser.vue?vue&type=script&lang=ts"
export * from "./ProcessItemAdminUser.vue?vue&type=script&lang=ts"

import "./ProcessItemAdminUser.vue?vue&type=style&index=0&id=11ad939f&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ad939f"]])

export default __exports__